import { SVGProps } from 'react';

function BorderVertical(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-border-vertical"
            {...props}
        >
            <path
                fill="currentColor"
                stroke="none"
                d="M1 1h1.5v1.5H1V1zm0 4h1.5v1.5H1V5zm0 4h1.5v1.5H1V9zm0 4h1.5v1.5H1v-1.5zm0 4h1.5v1.5H1v-1.5zM5 1h1.5v1.5H5V1zm0 8h1.5v1.5H5V9zm0 8h1.5v1.5H5v-1.5zM9.15 1h1.2v18h-1.2V1zm3.85 0h1.5v1.5h-1.5V1zm0 8h1.5v1.5h-1.5V9zm0 8h1.5v1.5h-1.5v-1.5zm4-16h1.5v1.5h-1.5V1zm0 4h1.5v1.5h-1.5V5zm0 4h1.5v1.5h-1.5V9zm0 4h1.5v1.5h-1.5v-1.5zm0 4h1.5v1.5h-1.5v-1.5z"
            />
        </svg>
    );
}

export default BorderVertical;
